var _path, _path2, _rect, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRestrictedDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 79,
    viewBox: "0 0 94 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M36.0432 6.35523C35.6606 6.16392 35.4693 6.06827 35.2686 6.03062C35.0909 5.99728 34.9085 5.99728 34.7308 6.03062C34.5301 6.06827 34.3388 6.16392 33.9562 6.35523L5.83301 20.4168L33.9562 34.4784C34.3388 34.6697 34.5301 34.7654 34.7308 34.803C34.9085 34.8364 35.0909 34.8364 35.2686 34.803C35.4693 34.7654 35.6606 34.6697 36.0432 34.4784L64.1663 20.4168L36.0432 6.35523Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 34.9999L33.9562 49.0615C34.3388 49.2528 34.5301 49.3485 34.7308 49.3861C34.9085 49.4194 35.0909 49.4194 35.2686 49.3861C35.4693 49.3485 35.6606 49.2528 36.0432 49.0615L64.1663 34.9999M5.83301 49.5832L33.9562 63.6448C34.3388 63.8361 34.5301 63.9318 34.7308 63.9694C34.9085 64.0028 35.0909 64.0028 35.2686 63.9694C35.4693 63.9318 35.6606 63.8361 36.0432 63.6448L64.1663 49.5832M5.83301 20.4166L33.9562 6.35499C34.3388 6.16368 34.5301 6.06803 34.7308 6.03038C34.9085 5.99704 35.0909 5.99704 35.2686 6.03038C35.4693 6.06803 35.6606 6.16368 36.0432 6.35499L64.1663 20.4166L36.0432 34.4782C35.6606 34.6695 35.4693 34.7651 35.2686 34.8028C35.0909 34.8361 34.9085 34.8361 34.7308 34.8028C34.5301 34.7651 34.3388 34.6695 33.9562 34.4782L5.83301 20.4166Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EF5350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 51C64 47.6863 66.6863 45 70 45C73.3137 45 76 47.6863 76 51V52.1503C76.2826 52.2123 76.5539 52.3024 76.816 52.436C77.5686 52.8195 78.1805 53.4314 78.564 54.184C78.8113 54.6694 78.9099 55.1861 78.9558 55.7482C79 56.2894 79 56.9537 79 57.7587V59.2413C79 60.0463 79 60.7106 78.9558 61.2518C78.9099 61.8139 78.8113 62.3306 78.564 62.816C78.1805 63.5686 77.5686 64.1805 76.816 64.564C76.3306 64.8113 75.8139 64.9099 75.2518 64.9558C74.7106 65 74.0463 65 73.2413 65H66.7587C65.9537 65 65.2894 65 64.7482 64.9558C64.1861 64.9099 63.6694 64.8113 63.184 64.564C62.4314 64.1805 61.8195 63.5686 61.436 62.816C61.1887 62.3306 61.0901 61.8139 61.0442 61.2518C61 60.7106 61 60.0463 61 59.2413V57.7587C61 56.9537 61 56.2894 61.0442 55.7482C61.0901 55.1861 61.1887 54.6694 61.436 54.184C61.8195 53.4314 62.4314 52.8195 63.184 52.436C63.4461 52.3024 63.7174 52.2123 64 52.1503V51ZM74 51V52.0016H66V51C66 48.7909 67.7909 47 70 47C72.2091 47 74 48.7909 74 51ZM71 57.5C71 56.9477 70.5523 56.5 70 56.5C69.4477 56.5 69 56.9477 69 57.5V59.5C69 60.0523 69.4477 60.5 70 60.5C70.5523 60.5 71 60.0523 71 59.5V57.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "white",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestrictedDocument);
export default __webpack_public_path__ + "static/media/iconRestrictedDocument.e81db46eccbe026d31b2b93c772940fb.svg";
export { ForwardRef as ReactComponent };